import script from "./DashBoardChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashBoardChart.vue?vue&type=script&lang=ts&setup=true"

import "./DashBoardChart.vue?vue&type=style&index=0&id=6d295a7a&scope=true&lang=css"

const __exports__ = script;

export default __exports__